import { render } from "./NovaVagaVie.vue?vue&type=template&id=60d0886e"
import script from "./NovaVagaVie.vue?vue&type=script&lang=js"
export * from "./NovaVagaVie.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__